<template>
        <div class="breadcrumbs px-mob py-6 bg-color">
            <ul class="pa-0 ma-0 d-flex align-center justify-center">
                <li>{{ itemsOrder.plan.title }}</li>
                <li class="px-3"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.75373 4.473C2.75373 4.473 2.8207 4.50888 2.82383 4.50888C2.16206 3.679 1.48093 2.86107 0.845832 2.00935C0.690982 1.80188 0.611464 1.47274 0.643376 1.21743C0.663255 1.05312 0.974525 0.777529 1.11159 0.801448C1.54004 0.875804 2.03127 0.96888 2.34987 1.23199C3.86384 2.48253 5.35846 3.75907 6.79972 5.09125C7.79944 6.01473 7.71626 6.97929 6.63022 7.81593C5.36526 8.79089 4.07414 9.73308 2.77727 10.6664C1.86177 11.3253 1.00487 11.3694 0.675287 10.824C0.265144 10.1449 0.586876 9.31814 1.51336 8.72121C2.2149 8.26883 4.80445 6.49519 4.78353 6.43383C4.12227 5.79114 3.46102 5.14897 2.79977 4.50628L2.75426 4.47404L2.75373 4.473Z"
                            fill="#201747" />
                    </svg></li>
                <li>Customise {{ (allergiesCount > 0) ? "( " + allergiesCount + " )" : "(0)" }} </li>
                <li class="px-3"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.75373 4.473C2.75373 4.473 2.8207 4.50888 2.82383 4.50888C2.16206 3.679 1.48093 2.86107 0.845832 2.00935C0.690982 1.80188 0.611464 1.47274 0.643376 1.21743C0.663255 1.05312 0.974525 0.777529 1.11159 0.801448C1.54004 0.875804 2.03127 0.96888 2.34987 1.23199C3.86384 2.48253 5.35846 3.75907 6.79972 5.09125C7.79944 6.01473 7.71626 6.97929 6.63022 7.81593C5.36526 8.79089 4.07414 9.73308 2.77727 10.6664C1.86177 11.3253 1.00487 11.3694 0.675287 10.824C0.265144 10.1449 0.586876 9.31814 1.51336 8.72121C2.2149 8.26883 4.80445 6.49519 4.78353 6.43383C4.12227 5.79114 3.46102 5.14897 2.79977 4.50628L2.75426 4.47404L2.75373 4.473Z"
                    fill="#201747" />
                </svg></li>
                <li>{{ itemsOrder.protein.title }}</li>
                   <li class="px-3"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2.75373 4.473C2.75373 4.473 2.8207 4.50888 2.82383 4.50888C2.16206 3.679 1.48093 2.86107 0.845832 2.00935C0.690982 1.80188 0.611464 1.47274 0.643376 1.21743C0.663255 1.05312 0.974525 0.777529 1.11159 0.801448C1.54004 0.875804 2.03127 0.96888 2.34987 1.23199C3.86384 2.48253 5.35846 3.75907 6.79972 5.09125C7.79944 6.01473 7.71626 6.97929 6.63022 7.81593C5.36526 8.79089 4.07414 9.73308 2.77727 10.6664C1.86177 11.3253 1.00487 11.3694 0.675287 10.824C0.265144 10.1449 0.586876 9.31814 1.51336 8.72121C2.2149 8.26883 4.80445 6.49519 4.78353 6.43383C4.12227 5.79114 3.46102 5.14897 2.79977 4.50628L2.75426 4.47404L2.75373 4.473Z"
                        fill="#201747" />
                    </svg></li>
                    <li><strong>Days</strong></li>
            </ul>
        </div>   
    <div class="wrap-plan flex-column px-md-6 ma-md-6 my-6 d-flex justify-center px-mob">
        <div>
            <h2 class="mb-4">How many days in a week would you like to eat our meals?</h2>
        </div>
        <div class="d-flex flex-row justify-center flex-wrap container mt-2">
            <div class="plan-item ma-1 ma-md-2 py-5 allergies" v-for="(plan, i) in weeklyPlanNum" :key="i" @click="setClassActiveDay(i)" :class="[plan.active ? 'active' : '']" >
                <div>
                    <h2 class="text-center">{{ plan.title }}</h2>
                </div>
            </div>  
        </div>
    </div>
    <div class="d-flex justify-center my-4 pt-4 px-mob">
        <button class="btn-main-app" :disabled="btnDisabled" @click="nextPage">Proceed to plan meals</button>
    </div>       
</template>

<script>
import Cookies from 'js-cookie'

export default {
    name: 'step-4',
    components: {       
    },
    data() {
        return {
            btnDisabled: true,
            weeklyPlanNum: [
                {
                    title: 3,
                    active: false
                },
                {
                    title: 4,
                    active: false
                },
                {
                    title: 5,
                    active: false
                },
                {
                    title: 6,
                    active: false
                },
                {
                    title: 7,
                    active: false
                },
            ],
        }
    },
    computed: {
        itemsOrder() {            
            return this.$store.getters.itemsOrder;
        },
        weeklyPlan() {
            return this.$store.getters.weeklyPlan;
        },  
        wizardMenu() {
            return this.$store.getters.wizardMenu;
        },
        lastStep() {
            return this.$store.getters.lastStep;
        },
        allergiesCount() {
            const allergies = this.$store.getters.getAllergies || [];
            return allergies.filter(allergie => allergie.isActive).length;

        },
        setNextPage() {
            return this.$store.getters.setNextPage;
        },
    },
    methods: {
        nextPage() {

            this.weeklyPlan.forEach((plan, index) => {
                if (index < this.itemsOrder.days) {
                    plan.active = true;
                } else {
                    plan.active = false;
                }
            })

            this.wizardMenu[3].isActive = this.wizardMenu[3].lastItem = false;
            this.wizardMenu[4].isActive = this.wizardMenu[4].lastItem = true;
            
            if (!this.setNextPage.includes('days')) {
                this.setNextPage.push('days');
                this.$store.commit('setNextPage', this.setNextPage);
            }
        },
        setClassActiveDay(i) {

            let countActive = 0;

            this.weeklyPlanNum.forEach((plan, index) => {

                plan.active = false;

                if (index === i) {
                    plan.active = !plan.active;
                }

                if (plan.active == true) {
                    
                    this.itemsOrder.days = plan.title;
                    countActive++;
                    Cookies.set('days', plan.title, { expires: 3600 });                    

                }

            });
 
            this.$store.commit('updateWeeklyPlan', this.itemsOrder.days);
            this.$store.commit('setItemsOrder', this.itemsOrder);

            if (countActive > 0) {
                this.btnDisabled = false;
            } else {
                this.btnDisabled = true;
            }

            this.$store.commit('setLastStep', false);
            
        },
    },
    async beforeMount() {

        let daysData = this.itemsOrder.days  ?? Cookies.get('days');
        if ( daysData > 3) {
            this.weeklyPlanNum.title = daysData;
             this.weeklyPlanNum.active = true;
        }

        if( daysData ) {

            this.weeklyPlanNum.forEach((plan) => {
                if (plan.title == daysData) {
                    plan.active = true;
                }             
            });

            this.itemsOrder.days = daysData;
            this.btnDisabled = false;
            this.weeklyPlan.forEach((plan, index) => {
            
                if (index < this.itemsOrder.days) {
                    plan.active = true;
                }
            });
           
            this.$store.commit('setItemsOrder', this.itemsOrder);

            if ( ! this.setNextPage.includes('days') ) {
                this.setNextPage.push('days');
                this.$store.commit('setNextPage', this.setNextPage);
                this.nextPage();
            }

        }
    },
}
</script>
<style lang="stylus">
    .table-meal-plan {
        background: #F1F3F9;

        h2 {
            font-size: 18px;
        }
    }

</style>
<style scoped lang="stylus">
.breadcrumbs
    ul   
        @media screen and (max-width: 460px) {
            max-width: 320px;
            flex-wrap: wrap;
            margin-left: auto!important;
            margin-right: auto!important;
        }
        list-style: none;


.wrap-plan
    text-align: center;

    .container {
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
    }

.plan-item
    min-width: 125px!important;
    cursor: pointer;
    width: 25%!important;
    max-width: unset!important;
    
    @media screen and (max-width: 450px) {
        min-width: 80px!important;
    }

    &.width-add {
        width: 48%;
        max-width: 225px;
        min-width: 0!important;

        @media screen and (max-width: 767px) {
            width: 47%;
            margin-bottom: 0!important;
        }
    }

    &.allergies {
         @media screen and (max-width: 767px) {
            min-width: 31%;
            max-width: 45%;
        }    
    }


</style>